import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Nav, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

type NavSocialProps = {
  name: string;
  icon: IconDefinition;
  color: string;
  href: string;
};

const NavCanvasSocialComponent: FunctionComponent<NavSocialProps> = ({ name, icon, color, href }) => {
  return (
    <Col xs={4} className="my-3">
      <Nav.Link className="p-0 text-center text-muted" rel="noopener nofollow" target="_blank" href={href}>
        <FontAwesomeIcon icon={icon} color={color} size="2x" />
        <div>{name}</div>
      </Nav.Link>
    </Col>
  );
};

export default React.memo(NavCanvasSocialComponent);
